require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./gymnase-secondaire-2-0-7-2.json") })
        }
      }, "path---gymnase-secondaire-2-0-7-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---gymnase-secondaire-2-0-7-2!./.cache/json/gymnase-secondaire-2-0-7-2.json
// module id = 456
// module chunks = 231608221292675